<template>
  <div class="wrapper-legend">
    {{minText}}
    <span class="color-bar" :style="styleObj"></span>
    {{maxText}}
  </div>
</template>

<script>
export default {
  props: {
    minText: {
      type: String,
      required: true,
    },
    maxText: {
      type: String,
      required: true,
    },
    colorRange: {
      type: Array,
      required: true,
    },
    dtSettings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    styleObj() {
      const colors = this.colorRange.join();
      return {
        background: `linear-gradient(to right, ${colors})`,
      };
    },
  },
};
</script>

<style scoped>
.wrapper-legend {
  padding-top: 0.85em;
  text-align: right;
}
.color-bar {
  display: inline-block;
  width: 200px;
  height: 10px;
}
</style>
